export const REQUIRED_MESSAGE = 'Required';
export const LENGTH_PASSWORD_CHARACTER_MESSAGE = 'Password should be at least 8 characters.';
export const LENGTH_CHARACTER_MESSAGE_CELL_PHONE = 'Cell phone should be at least 10 characters.';
export const MESSAGE_INVALID_EMAIL = 'Invalid email';
export const ENTER_VALID_EMAIL_MESSAGE = 'Please enter a valid email address';
